<div class="inline-flex items-center  p-1 rounded-lg gap-0.5">
  <button
    type="button"
    class="flex items-center justify-center w-8 h-8 rounded-md transition-all duration-200 "
    [class.bg-white]="value() === 'table'"
    [class.shadow-sm]="value() === 'table'"
    (click)="setTable()"
    [attr.aria-label]="'viewToggle.table' | translate"
  >
    <mat-icon class="text-sm leading-none" [class.text-primary]="value() === 'table'" [class.text-muted]="value() !== 'table'">view_list</mat-icon>
  </button>
  <button
    type="button"
    class="flex items-center justify-center w-8 h-8 rounded-md transition-all duration-200"
    [class.bg-white]="value() === 'cards'"
    [class.shadow-sm]="value() === 'cards'"
    (click)="setCards()"
    [attr.aria-label]="'viewToggle.cards' | translate"
  >
    <mat-icon class="text-sm leading-none" [class.text-primary]="value() === 'cards'" [class.text-muted]="value() !== 'cards'">apps</mat-icon>
  </button>
</div>
